export const cardErrorMessage: Record<string, string> = {
  invalid_expiry_month: "Mês de vencimento do cartão inválido",
  invalid_expiry_year: "Ano de vencimento do cartão inválido",
  invalid_cvc: "Código de segurança do cartão inválido",
  incorrect_number: "Número do cartão inválido",
};
